import levelsData from "../../generated/levels.json" with { type: "json" };
import { FRAME_RATE } from "../core/constants.js";
import { SimulationClock } from "../core/simulation-clock.js";
import { ScriptedInputState } from "../core/scripted-input.js";
import { LevelRuntime } from "../game/level-runtime.js";
import { LevelOneRuntime } from "../game/level-one-runtime.js";
import { LevelFourRuntime } from "../game/level-four-runtime.js";
import { LevelSixRuntime } from "../game/level-six-runtime.js";
import { LevelSevenRuntime } from "../game/level-seven-runtime.js";
import { LevelEightRuntime } from "../game/level-eight-runtime.js";
import { LevelElevenRuntime } from "../game/level-eleven-runtime.js";
import { LevelFifteenRuntime } from "../game/level-fifteen-runtime.js";
import { LevelFourteenRuntime } from "../game/level-fourteen-runtime.js";
import { LevelNineRuntime } from "../game/level-nine-runtime.js";
import { LevelTenRuntime } from "../game/level-ten-runtime.js";
import { LevelThirteenRuntime } from "../game/level-thirteen-runtime.js";
import { LevelTwelveRuntime } from "../game/level-twelve-runtime.js";
import { LevelTwoRuntime } from "../game/level-two-runtime.js";
import { LevelThreeRuntime } from "../game/level-three-runtime.js";
import { LevelFiveRuntime } from "../game/level-five-runtime.js";
import { LevelSixteenRuntime } from "../game/level-sixteen-runtime.js";
import { LevelSeventeenRuntime } from "../game/level-seventeen-runtime.js";

const LAST_LEVEL_ID = 17;

function getPlayerHitboxHalfExtent(player) {
  const size = player.radius * 2;
  return size / 2 * (Math.abs(Math.cos(player.body.GetAngle())) + Math.abs(Math.sin(player.body.GetAngle())));
}

function createRuntime(levelId, levelData, clock, spikesKill, fixedLevelTransitionTiming, tasDeathWarp) {
  if (!levelData) {
    throw new Error(`Unknown level ${levelId}.`);
  }
  let runtime;
  switch (levelId) {
    case 1:
      runtime = new LevelOneRuntime(levelData, clock, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 2:
      runtime = new LevelTwoRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 3:
      runtime = new LevelThreeRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 4:
      runtime = new LevelFourRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 5:
      runtime = new LevelFiveRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 6:
      runtime = new LevelSixRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 7:
      runtime = new LevelSevenRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 8:
      runtime = new LevelEightRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 9:
      runtime = new LevelNineRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 10:
      runtime = new LevelTenRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 11:
      runtime = new LevelElevenRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 12:
      runtime = new LevelTwelveRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 13:
      runtime = new LevelThirteenRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 14:
      runtime = new LevelFourteenRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 15:
      runtime = new LevelFifteenRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 16:
      runtime = new LevelSixteenRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    case 17:
      runtime = new LevelSeventeenRuntime(levelData, clock, null, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
    default:
      runtime = new LevelRuntime(levelData, clock, {
        audioEnabled: false,
        assetsEnabled: false,
        fixedLevelTransitionTiming,
        tasDeathWarp,
      });
      break;
  }
  runtime.setSpikesKill?.(spikesKill);
  runtime.setFixedLevelTransitionTiming?.(fixedLevelTransitionTiming);
  runtime.setTasDeathWarp?.(tasDeathWarp);
  return runtime;
}

function runtimeNeedsStartGate(runtime) {
  return runtime?.beginFlag === true;
}

function getTelemetry(runtime, clock) {
  const player = runtime?.player;
  const livePlayer = player?.isLive?.() ? player : null;
  const velocity = livePlayer ? livePlayer.body.GetLinearVelocity() : null;
  const angularVelocity = livePlayer ? livePlayer.body.GetAngularVelocity() : null;
  const position = livePlayer ? livePlayer.body.GetPosition() : null;
  const angle = livePlayer ? livePlayer.body.GetAngle() : null;
  const hitboxHalfExtent = livePlayer ? getPlayerHitboxHalfExtent(livePlayer) : 0;
  const frame = clock.frames;
  const x = livePlayer ? position.x * 30 : 0;
  const y = livePlayer ? position.y * 30 : 0;
  return {
    frame,
    frameTime: frame / FRAME_RATE,
    vx: velocity?.x ?? 0,
    vy: velocity?.y ?? 0,
    rotationVelocity: angularVelocity ? angularVelocity * (180 / Math.PI) : 0,
    x,
    y,
    rotation: livePlayer ? (angle * (180 / Math.PI)) % 360 : 0,
    hitboxRightX: x + hitboxHalfExtent,
    hitboxLeftX: x - hitboxHalfExtent,
    hitboxTopY: y - hitboxHalfExtent,
    hitboxBottomY: y + hitboxHalfExtent,
  };
}

function isPlayerAlive(runtime) {
  return runtime?.player?.isLive?.() === true;
}

export class EvaluationSession {
  constructor({ levelId, scriptText, scriptEvents = null, spikesKill = false, fixedLevelTransitionTiming = false, tasDeathWarp = false }) {
    this.levelId = levelId;
    this.scriptText = scriptText;
    this.scriptEvents = scriptEvents;
    this.spikesKill = spikesKill;
    this.fixedLevelTransitionTiming = fixedLevelTransitionTiming;
    this.tasDeathWarp = tasDeathWarp;
    this.clock = new SimulationClock();
    this.input = new ScriptedInputState(new EventTarget());
    if (scriptEvents) {
      this.input.setBotEvents(scriptEvents, {
        triggerChange: false,
        replayBeforeFrame: 0,
        scriptText: scriptText ?? "",
      });
    } else {
      this.input.setBotScript(scriptText ?? "", { triggerChange: false, replayBeforeFrame: 0 });
    }
    const levelData = levelsData.levels.find((entry) => entry.id === levelId);
    this.runtime = createRuntime(levelId, levelData, this.clock, spikesKill, fixedLevelTransitionTiming, tasDeathWarp);
    this.clock.reset();
    if (!runtimeNeedsStartGate(this.runtime)) {
      this.clock.unpause();
    }
    this.input.resetRace();
  }

  runUntil(targetFrame) {
    let aliveAtTarget = false;
    while (this.clock.frames < targetFrame && !this.isPaused()) {
      this.input.syncFrame(this.clock.frames);
      this.runtime.update(this.input);
      const playerAlive = isPlayerAlive(this.runtime);
      if (this.runtime.complete) {
        if (this.levelId < LAST_LEVEL_ID) {
          this.clock.Pause();
        }
        aliveAtTarget = this.clock.frames >= targetFrame && playerAlive;
        this.input.beginFrame();
        break;
      }
      if (!playerAlive) {
        this.clock.Pause();
        aliveAtTarget = false;
        this.input.beginFrame();
        break;
      }
      if (this.runtime.failed) {
        this.clock.Pause();
        aliveAtTarget = false;
        this.input.beginFrame();
        break;
      }
      aliveAtTarget = this.clock.frames >= targetFrame && playerAlive;
      this.input.beginFrame();
    }
    if (this.clock.frames >= targetFrame) {
      aliveAtTarget = isPlayerAlive(this.runtime);
    }
    const telemetry = getTelemetry(this.runtime, this.clock);
    return {
      targetFrame,
      reachedFrame: telemetry.frame,
      telemetry,
      complete: Boolean(this.runtime?.complete),
      paused: this.isPaused(),
      aliveAtTarget,
      reachedTarget: telemetry.frame >= targetFrame && aliveAtTarget,
      seconds: telemetry.frame / FRAME_RATE,
    };
  }

  isPaused() {
    return this.clock.paused === true;
  }

  dispose() {
    this.input.dispose();
  }
}
